import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import bg from '../../images/highlights.PNG';
import './css/township.css';

const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 0 },
        items: 1,
        slidesToSlide: 1, // optional, default to 1.
      },
  };

const Township = () => {
    return (
        <div className='township-highlights'>
            <div className='township-info'>
                <div>
                    <h2>mega gated community highlights</h2>
                    <div>
                        <Carousel
                        infinite={true}
                        showDots={true}
                        draggable={true}
                        swipeable={true}
                        autoPlaySpeed={100}
                        customTransition='all .5'
                        transitionDuration={500}
                        responsive={responsive}
                        className='township-highlight'
                        containerClass='carousel-container'
                        removeArrowOnDeviceType={["desktop"]}
                        dotListClass='custom-dot-list-style'
                        itemClass='carousel-item-padding-40-px'
                    >
                            <div className='township-highlight-boxes'>
                                <div className='township-highlight-content'>
                                    <h3><span>01 </span>a mega christian gated community project</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>02 </span>its a open plot and housing project</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>03 </span>water tap connection for all plots</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>04 </span>main entrance arch with security</h3>
                                    <p>{''}</p>
                                </div>
                            </div>

                            <div className='township-highlight-boxes'>
                                <div className='township-highlight-content'>
                                    <h3><span>07 </span>avenue plantation</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>08 </span>40/30' feet black top roads</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>09 </span>AC function hall with dining</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>10 </span>church prayer hall</h3>
                                    <p>{''}</p>
                                </div>
                            </div>

                            <div className='township-highlight-boxes'>
                                <div className='township-highlight-content'>
                                    <h3><span>11 </span>open drainages</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>12 </span>electricity and street lights</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>13 </span>children park</h3>
                                    <p>{''}</p>
                                </div>
                                <div className='township-highlight-content'>
                                    <h3><span>14 </span>24 hrs security</h3>
                                    <p>{''}</p>
                                </div>
                            </div>

                        </Carousel>
                    </div>
                </div>
            </div>
            <div data-aos="zoom-in-up" data-aos-duration="1000">
                <div className='township-img'><img src={bg} alt='Best Township in vijayawada' height='100%' width='100%' /> </div>
            </div>            
        </div>
    )
}

export default Township;
